<template>
  <div :class="canUpload && saveInner && canUploadFile ? 'w-100' : ''">
    <div class="d-inline-flex titleType">
      <p :is="titleTag" :class="titleClass" v-if="title">{{ title }}</p>
      <button
        v-if="canUpload && saveInner && canUploadFile"
        @click="updateImage"
        :disabled="!canUploadFile"
        class="btn btn-success"
      >
        Lưu
      </button>
    </div>
    <div class="img-list" v-if="fileType === 'image' && canUpload">
      <ul v-viewer class="m-0">
        <li v-for="(item, index) in fileUploads" :key="index">
          <a href="javascript:void(0)">
            <img :src="url(item) || item" />
          </a>
          <span
            v-if="canRemoveOldFile === true ? canUpload : canUpload && !!item.file"
            @click="removeFile(item.id)"
          >
            <i class="bx bx-trash bx-sm"></i>
          </span>
        </li>
        <li>
          <div v-if="canUpload && fileUploads.length < maxFile" class="add-img">
            <span class="bx bx-plus text-center"></span>
            <input type="file" :ref="uniqueKey" :accept="accept" multiple @change="uploadFile" />
          </div>
        </li>
      </ul>
    </div>
    <div class="img-list" v-if="fileType === 'file' && canUpload">
      <ul class="m-0">
        <li v-for="(item, index) in fileUploads" :key="index">
          <a target="_blank" :href="urlWithFile(url(item) || item)">
            <img src="@/assets/img/file.jpg" />
          </a>
          <span
            v-if="canRemoveOldFile === true ? canUpload : canUpload && !!item.file"
            @click="removeFile(item.id)"
          >
            <i class="bx bx-trash bx-sm"></i>
          </span>
        </li>
        <li>
          <div v-if="canUpload && fileUploads.length < maxFile" class="add-img">
            <span class="bx bx-plus text-center"></span>
            <input type="file" :ref="uniqueKey" :accept="accept" multiple @change="uploadFile" />
          </div>
        </li>
      </ul>
    </div>
    <div class="img-list" v-if="!canUpload">
      <ul class="m-0" v-if="readOnlyFileList.length">
        <li v-for="(item, index) in readOnlyFileList" :key="`file-${index}`">
          <a target="_blank" :href="urlWithFile(url(item) || item)">
            <img src="@/assets/img/file.jpg" />
          </a>
        </li>
      </ul>
      <ul class="m-0 video-box-list" v-if="readOnlyVideoList.length">
        <li v-for="(item, index) in readOnlyVideoList" :key="`video-${index}`">
          <div class="video-box">
            <div class="video-box__thumb">
              <i class="bx bx-video"></i>
              <span class="video-box__ext">{{
                (getFileExtension(item) || 'video').toUpperCase()
              }}</span>
            </div>
            <button type="button" class="video-box__action" @click="openVideoPreview(item)">
              Xem video
            </button>
          </div>
        </li>
      </ul>
      <ul class="m-0" v-viewer v-if="readOnlyImageList.length">
        <li v-for="(item, index) in readOnlyImageList" :key="`img-${index}`">
          <a
            v-if="item.isOpenTab && item.isOpenTab === true"
            target="_blank"
            :href="urlWithFile(url(item) || item)"
          >
            <img src="@/assets/img/file-mpos.svg" />
          </a>
          <a v-else href="javascript:void(0)">
            <img :src="url(item) || item" />
          </a>
        </li>
      </ul>
      <ul v-if="fileUploads.length <= 0">
        <li>
          <div class="add-img">
            <span class="font-size-12">Không có dữ liệu</span>
          </div>
        </li>
      </ul>
      <slot></slot>
    </div>
    <b-modal
      id="upload-multiple-video-preview"
      centered
      size="lg"
      hide-footer
      v-model="showVideoModal"
      @hidden="handleVideoModalHidden"
    >
      <template #modal-title>
        {{ previewVideoExt ? `Xem ${previewVideoExt}` : 'Xem video' }}
      </template>
      <div class="video-preview-wrapper" v-if="previewVideoUrl">
        <video ref="previewVideo" class="video-modal-video" controls :src="previewVideoUrl"></video>
      </div>
      <div v-else class="text-center py-3 font-weight-bold">Không tìm thấy video</div>
    </b-modal>
  </div>
</template>

<script>
  import { v4 as uuidv4 } from 'uuid'
  import cloneDeep from 'lodash/cloneDeep'
  export default {
    props: {
      lsData: {
        type: Array,
        require: true,
      },
      keyUrl: {
        type: String,
        default: 'url',
      },
      fileType: {
        type: String,
        default: 'image',
      },
      titleTag: {
        type: String,
        default: 'p',
      },
      titleClass: {
        type: String,
        default: '',
      },
      title: {
        type: String,
      },
      accept: {
        type: String,
        default: 'image/jpeg, image/png',
      },
      maxFile: {
        type: Number,
        default: 10,
      },
      // maxFileSize: {
      //   type: Number,
      //   // default: 20
      //   default: () => Number((window._env_?.VUE_APP_MAX_FILE_SIZE ?? process.env.VUE_APP_MAX_FILE_SIZE) || 5)

      // },
      maxFileSize: {
        type: Number,
        default: () =>
          Number((window._env_?.VUE_APP_MAX_FILE_SIZE ?? process.env.VUE_APP_MAX_FILE_SIZE) || 50), // Mặc định 50MB
      },
      maxImageFileSize: {
        type: Number,
        default: () =>
          Number(
            (window._env_?.VUE_APP_MAX_IMAGE_FILE_SIZE ??
              process.env.VUE_APP_MAX_IMAGE_FILE_SIZE) ||
              5
          ), // Mặc định 5MB
      },
      uniqueKey: {
        type: String,
        default: () => {
          return uuidv4()
        },
      },
      canUpload: {
        type: Boolean,
        default: true,
      },
      saveInner: {
        type: Boolean,
        default: false,
      },
      canRemoveOldFile: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        fileUploads: [],
        showVideoModal: false,
        previewVideoUrl: '',
        previewVideoExt: '',
      }
    },
    watch: {
      lsData(val) {
        if (val) this.fileUploads = val ?? []
      },
    },
    computed: {
      canUploadFile() {
        return this.fileUploads.find(e => e.file)
      },
      readOnlyFileList() {
        return this.fileUploads.filter(item => {
          const fileUrl = this.url(item) || item
          return typeof fileUrl === 'string' && this.isFile(fileUrl) && !this.isVideoFile(item)
        })
      },
      readOnlyImageList() {
        return this.fileUploads.filter(item => {
          const fileUrl = this.url(item) || item
          return typeof fileUrl === 'string' && !this.isFile(fileUrl) && !this.isVideoFile(item)
        })
      },
      readOnlyVideoList() {
        return this.fileUploads.filter(item => this.isVideoFile(item))
      },
    },
    created() {
      if (this.lsData) {
        const data = this.lsData.map(s => {
          if (typeof s === 'string') {
            return {
              id: uuidv4(),
              [this.keyUrl]: s,
            }
          }
          return s
        })
        this.fileUploads = cloneDeep(data) ?? []
      }
    },
    methods: {
      url(item) {
        return item?.[this.keyUrl]
      },
      isFile(filename) {
        var pattern = /\.pdf|doc|docx|xlsx|xls|mp4|mov|avi|mkv$/i
        return pattern.test(filename)
      },
      urlWithFile(filename) {
        var pattern = /\.pdf|doc|docx$/i
        if (pattern.test(filename)) return '/viewer/pdf?url=' + filename
        else return filename
      },
      getExtensionFromEncodedLink(url) {
        try {
          const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
          const parsedUrl = new URL(url, base)
          const params = parsedUrl.searchParams
          const data = params.get('data')
          if (!data) return null
          const decoded = JSON.parse(atob(data))
          const filePath = decoded?.files
          if (!filePath) return null
          const ext = filePath.split('.').pop()
          return ext ? ext.toLowerCase() : null
        } catch (error) {
          return null
        }
      },
      getFileExtension(item) {
        const fileObj = item?.file
        if (fileObj?.name) {
          const extFromName = fileObj.name.split('.').pop()
          if (extFromName) return extFromName.toLowerCase()
        }
        if (fileObj?.type && fileObj.type.includes('/')) {
          const mimeExt = fileObj.type.split('/').pop()
          if (mimeExt) return mimeExt.toLowerCase()
        }
        const rawUrl = this.url(item) || item
        if (typeof rawUrl !== 'string') return null
        const encodedExt = this.getExtensionFromEncodedLink(rawUrl)
        if (encodedExt) return encodedExt
        const cleanUrl = rawUrl.split(/[?#]/)[0]
        if (!cleanUrl) return null
        const lastSegment = cleanUrl.split('/').pop() || ''
        if (!lastSegment || !lastSegment.includes('.')) return null
        const ext = lastSegment.split('.').pop()
        return ext ? ext.toLowerCase() : null
      },
      isVideoFile(item) {
        const ext = this.getFileExtension(item)
        if (!ext) return false
        return ['mp4', 'mov', 'avi', 'mkv'].includes(ext)
      },
      removeFile(id) {
        // const file = this.fileUploads.find(s => s.id === id)
        // Sau này sẽ call api xoá file với các file có file.status === uploaded
        this.fileUploads = this.fileUploads.filter(s => s.id !== id)
        this.$emit('syncFile', this.fileUploads, this.uniqueKey)
      },
      isImageFile(file) {
        return file.type.startsWith('image/')
      },

      getMaxFileSize(file) {
        return this.isImageFile(file) ? this.maxImageFileSize : this.maxFileSize
      },
      validateFile(file) {
        if (this.fileUploads.length >= this.maxFile) {
          this.showFailMx(`Bạn chỉ được upload tối đa ${this.maxFile} file`)
          return false
        }
        if (this.accept !== '*/*') {
          const fomatUpload = this.accept.split(',').map(s => s.trim())
          if (!fomatUpload.some(type => file.type.startsWith(type.replace('/*', '')))) {
            this.showFailMx('Định dạng file của bạn không hợp lệ')
            return false
          }
        }
        const maxSize = this.getMaxFileSize(file)
        if (file.size > maxSize * 1024 * 1024) {
          this.showFailMx(`Bạn chỉ được upload tối đa ${this.maxFileSize}MB`)
          return false
        }
        return true
      },

      uploadFile(e) {
        const files = e.target.files
        if (files.length > 0) {
          for (const file of files) {
            if (!this.validateFile(file)) return
            this.fileUploads.push({
              id: uuidv4(),
              name: file.name,
              [this.keyUrl]: URL.createObjectURL(file),
              file,
              type: this.uniqueKey,
            })
          }
          this.$refs[this.uniqueKey].value = null
          this.$emit('syncFile', this.fileUploads, this.uniqueKey)
        }
      },

      updateImage() {
        this.$emit('updateImage', this.fileUploads, this.uniqueKey)
      },
      openVideoPreview(item) {
        const fileUrl = this.url(item) || item
        this.previewVideoUrl = fileUrl
        this.previewVideoExt = (this.getFileExtension(item) || 'video').toUpperCase()
        this.showVideoModal = true
        this.$nextTick(() => {
          const video = this.$refs.previewVideo
          if (video && video.play) {
            video.load()
            video.play().catch(() => {})
          }
        })
      },
      handleVideoModalHidden() {
        const video = this.$refs.previewVideo
        if (video && video.pause) {
          video.pause()
          video.currentTime = 0
        }
        this.previewVideoUrl = ''
        this.previewVideoExt = ''
      },
    },
  }
</script>
<style scoped>
  .titleType {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-bottom: 5px;
  }
  .video-box-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    list-style: none;
    padding: 0;
  }
  .video-box-list li {
    list-style: none;
  }
  .video-box {
    width: 100px;
    height: 140px;
    border-radius: 6px;
    background: #f8f8fb;
    border: 1px solid #dde1ef;
    box-shadow: 0 1px 4px rgba(33, 50, 91, 0.08);
    display: flex;
    flex-direction: column;
    justify-items: center;
    justify-content: space-between;
    padding-top: 20px;
  }
  .video-box__thumb {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 16px 8px 10px;
    color: #5d6ab3;
    font-weight: 600;
    font-size: 14px;
  }
  .video-box__thumb i {
    font-size: 28px;
    margin-bottom: 8px;
  }
  .video-box__ext {
    letter-spacing: 0.5px;
    color: blue !important;
    border-radius: 2px !important;
    font-size: 14px;
  }
  .video-box__action {
    border: none;
    border-top: 1px solid #dde1ef;
    width: 100%;
    padding: 8px;
    border-radius: 0 0 6px 6px;
    background: #fff;
    color: #2f80ed;
    font-weight: 600;
    font-size: 12px;
    cursor: pointer;
  }
  .video-box__action:hover {
    background: #f0f5ff;
  }
  .video-box__action:focus {
    outline: none;
  }
  .video-modal-video {
    width: 100%;
    max-height: 70vh;
  }
  .video-preview-wrapper {
    width: 100%;
  }
</style>
